import axios from 'axios';

/**
 * D2 (AC3): POST a tenant's pasted KB text to the /kb endpoint — the ONLY writer of an agent's
 * contentPath. Extracted from the VirtualizationTab control so the client→server call is
 * DRIVABLE in a test (the AC3 rejection was exactly a UI that never called this endpoint — it
 * fired a PATCH instead; a driving test of this function catches that regression).
 *
 * @param apiBase '/api' (tenant/session) or '/api/backoffice' (super-admin) — must match the
 *   surface's auth. The stranger surface is '/api' (isAuthenticated session).
 * @returns { ok, error? } — ok=false carries the server's human-readable reason (503/413/…).
 */
export async function postKnowledge(
  apiBase: string,
  agentId: string,
  text: string,
  authHeader?: string
): Promise<{ ok: boolean; error?: string; contentPath?: string }> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (authHeader) headers['Authorization'] = authHeader;
  try {
    const res = await axios.post(
      `${apiBase}/virtual-agents/${agentId}/kb`,
      { text },
      { headers }
    );
    return { ok: true, contentPath: res.data?.contentPath };
  } catch (err: any) {
    return { ok: false, error: err?.response?.data?.error || 'Could not add knowledge. Please try again.' };
  }
}
